export const KEYBOARD_EVENT = "keyboard/KEYBOARD_EVENT";
export const SET_USER_TYPING_STATUS = "keyboard/SET_USER_TYPING_STATUS";
export const SET_OFFSET_COPY_PASTE = "keyboard/SET_OFFSET_COPY_PASTE";
export const SET_CTRL_IS_PRESSING = "keyboard/SET_CTRL_IS_PRESSING";
